import store from '../stateManagement/store';

export default function AuthHeader(): { Authorization?: string } {
  const token = store.getState().auth?.idToken;
  if (token) {
    return { Authorization: 'Bearer ' + token };
  }
  return {};
}